<!--
 * @Author: awu
 * @Date: 2020-11-12 23:22:57
 * @LastEditors: awu
 * @LastEditTime: 2020-12-08 19:43:23
 * @Description: file content
-->
<template>
    <div class="product">
        <div class="backHome" @click="backHome">
            <img src="../../assets/user/close.png" alt="" />
        </div>
        <h1>{{ title }}</h1>
        <div class="contact">
            <div class="contac-left">
                <p>
                    <span>{{ contact.msg1 }} :</span><span>{{ manager_name }}</span>
                </p>
                <!--
                <p>
                    <span>{{ contact.msg2 }} :</span><span>{{ manager_phone }}</span>
                </p>-->
                <p>
                    <span>{{ contact.msg4 }} :</span><span>{{ phone }}</span>
                </p>
                <p>
                    <span>{{ contact.msg5 }} :</span><span>{{ email }}</span>
                </p>
                <p>
                    <span>{{ contact.msg6 }} :</span><span>{{ website }}</span>
                </p>
                <p>
                    <span>{{ contact.msg7 }} :</span><span>{{ address }}</span>
                </p>
            </div>
            <div class="contac-right">
                <img v-if="logo" :src="logo" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    name:"Contact",
    props: ['exhibitionId'],
    data() {
        return {
            manager_name: "", //联系人
            manager_phone: "", //联系人电话
            email: "", //公司邮箱
            phone: "", //企业电话
            website: "", //公司网址
            address: "", //企业地址
            title: "", //标题
            logo: "", //logo
            company_id: null
        };
    },
    mounted() {
        this.company_id = Number(this.$route.query.company_id)
        this.manager_name = "";
        this.manager_phone = "";
        this.email = "";
        this.phone = "";
        this.website = "";
        this.address = "";
        this.getExhibitor();
    },
    methods: {
        backHome() {
            this.$root.$emit("close");
            this.$emit("cancel",4)
        },
        getExhibitor() {
          debugger
            api.getExhibitionDetali({
                id: this.company_id,
                params: {
                    exhibition_id: this.exhibitionId
                }
            }).then((res) => {
                console.log(res)
                this.title = res.info.company.name;
                this.logo = (res.info.profile.cn.images[0] && res.info.profile.cn.images[0].url) || '';
                this.manager_name = res.info.company.manager_name;
                this.manager_phone = res.info.company.manager_phone;
                this.email = res.info.company.email;
                this.phone = res.info.company.phone;
                this.website = res.info.company.website;
                this.address = res.info.company.address;
            });
        }
    },
    computed: {
        contact() {
            return this.$t("contact");
        }
    }
};
</script>

<style lang="scss" scoped>
.product {
    width: 667px;
    background-color: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 8px 10px 4px rgba(0, 0, 0, 0.3);
    border-radius: 30px;
    box-sizing: border-box;
    padding: 13px 33px 20px;
    > h1 {
        width: 100%;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #09468c;
        line-height: 28px;
        text-align: center;
        margin-bottom: 33px;
    }
    .contact {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .contac-left {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #09468c;
            line-height: 24px;
            span:last-of-type {
                margin-left: 12px;
            }
        }
        .contac-right {
            width: 133px;
            height: 133px;
            background-color: #eee;
            >img{
                width: 100%;
                height: 100%;
            }
        }
    }
}
.backHome {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 21px;
    right: 21px;
    border-radius: 50%;
    cursor: pointer;
    > img {
        width: 100%;
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/contact/index.vue